import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Chip,
  Autocomplete,
} from "@mui/material";

const ScheduleForm = ({ availableStaff = [], onSubmit, onCancel, loading }) => {
  const [form, setForm] = useState({
    title: "",
    date: "",
    location: "",
    startTime: "",
    endTime: "",
    staffIds: [],
    notes: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ ...form, id: `DAY${Date.now()}` });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Shoot Title *"
            fullWidth
            required
            disabled={loading}
            placeholder="Pre Wedding Shoot"
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Date *"
            type="date"
            fullWidth
            required
            disabled={loading}
            InputLabelProps={{ shrink: true }}
            value={form.date}
            onChange={(e) => setForm({ ...form, date: e.target.value })}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Location"
            fullWidth
            disabled={loading}
            value={form.location}
            onChange={(e) => setForm({ ...form, location: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Start Time"
            fullWidth
            disabled={loading}
            placeholder="06:00 AM"
            value={form.startTime}
            onChange={(e) => setForm({ ...form, startTime: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="End Time"
            fullWidth
            disabled={loading}
            placeholder="10:00 AM"
            value={form.endTime}
            onChange={(e) => setForm({ ...form, endTime: e.target.value })}
          />
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            multiple
            options={availableStaff}
            disabled={loading}
            getOptionLabel={(o) => o.name}
            onChange={(e, val) =>
              setForm({ ...form, staffIds: val.map((v) => v.userId) })
            }
            renderInput={(params) => (
              <TextField {...params} label="Assign Staff" />
            )}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  label={option.name}
                  {...getTagProps({ index })}
                  key={option.userId}
                />
              ))
            }
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Notes"
            fullWidth
            multiline
            rows={2}
            disabled={loading}
            value={form.notes}
            onChange={(e) => setForm({ ...form, notes: e.target.value })}
          />
        </Grid>
      </Grid>
      <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
        <Button type="submit" variant="contained" fullWidth disabled={loading}>
          Add Schedule
        </Button>
        <Button
          variant="outlined"
          color="inherit"
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </Button>
      </Box>
    </form>
  );
};

export default ScheduleForm;
